
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class TripDestinationsSelect extends Vue {
  @Prop({ required: true }) value: number | null;

  get selectedTripDestinations(): number {
    return this.value === null || this.value === undefined ? -1 : this.value;
  }

  set selectedTripDestinations(val: number) {
    this.$emit("input", val);
  }

  get validationRules() {
    return [v => v >= 0 || this.$i18n.translate("validation.rules.required", "Required")];
  }

  get tripDestinations() {
    return [
      {
        text: this.$i18n.translate("generic.select", "Select"),
        value: -1,
      },
      {
        text: this.$i18n.translate( "transportationPermission.tripDestinations.homeToMain", "Home-Main place" ),
        value: 0,
      },
      {
        text: this.$i18n.translate("transportationPermission.tripDestinations.grouping", "Grouping"),
        value: 1,
      },
      {
        text: this.$i18n.translate("transportationPermission.tripDestinations.passengerDestinations", "Passengers destinations"),
        value: 2,
      },
      {
        text: this.$i18n.translate("transportationPermission.tripDestinations.homeSecondary", "Home-Secondary place"),
        value: 4,
      },
      {
        text: this.$i18n.translate("transportationPermission.tripDestinations.mainSecondary", "Main-Secondary place"),
        value: 5,
      },
      {
        text: this.$i18n.translate("transportationPermission.tripDestinations.allDestinations", "All destinations"),
        value: 3,
      },
    ];
  }
}
